import Heading from "./Heading";

export default function Intro({ heading, content, onClick }) {
    return (
        <div className="test__intro">
            <div className="test__wrap">
                {heading && <Heading>{heading}</Heading>}

                {content && (
                    <div className="test__intro-text" dangerouslySetInnerHTML={{__html: content}} />
                )}

                <button className="test__next-button" onClick={onClick} type="button">
                    Start the test
                </button>
            </div>
        </div>
    )
}